// project-imports
import RechargeHistoryTable from '../member-details/rechargeHistoryTable';
import MemberBookings from './tabs/bookings';
import MemberFollowUp from './tabs/followUp';
import EditOrganizationDetails from './tabs/orgDetails';
import Requirements from './tabs/requirements';
import MemberSearch from './tabs/searches';
import Tickets from './tabs/tickets';
import Escalations from './tabs/escalations';
import CouponsMaster from './tabs/Coupons';

export const title = 'Member Priority Dashboard';
export const DASHBOARD_TITLE = 'Member Dashboard';
export const DASHBOARD_VIEW = 'dashboard';
export const VIEW_TYPE_MPD_VIEW = 'member-priority-dashboard';
export const MEMBER_LIST_VIEW = 'member-list';
// export const categoryCount = 4; // no. of buckets
// export const fractionalSize = 100 / categoryCount;

export const categories = [
    { activityId: '4', categoryName: 'Dormant' },
    { activityId: '3', categoryName: 'Not Engaged' },
    { activityId: '2', categoryName: 'Engaged' },
    { activityId: '1', categoryName: 'Highly Engaged' }
];

// startDate = endDate - (duration + 1)
export const durationFilterData = {
    all: '364',
    yesterday: '1',
    last_7_days: '6',
    last_15_days: '14',
    last_30_days: '29',
    last_60_days: '59',
    last_90_days: '89'
};

export const recentActivityHeadCells = [
    { id: 'date', numeric: true, disablePadding: false, align: 'left', label: 'Date' },
    { id: 'campaign', numeric: false, disablePadding: false, label: 'Campaign' },
    { id: 'action', numeric: false, disablePadding: false, label: 'Action' },
    { id: 'remarks', numeric: false, disablePadding: false, label: 'Remarks' },
    { id: 'done_by', numeric: false, disablePadding: false, label: 'Done By' }
];

export const GMV_TYPE_ID = 4;
export const SEARCH_TYPE_ID = 3;

export const TAB_VALUES = [
    {
        id: 'followUp',
        label: 'Follow Up'
    },
    {
        id: 'requirement',
        label: 'Requirement'
    },
    {
        id: 'searches',
        label: 'Searches'
    },
    {
        id: 'bookings',
        label: 'Bookings'
    },
    {
        id: 'tickets',
        label: 'Tickets'
    },
    {
        id: 'escalations',
        label: 'Escalations'
    },
    {
        id: 'orgDetails',
        label: 'Org Details'
    },
    {
        id: 'rechargeHistory',
        label: 'Recharge History'
    },
    {
        id: 'Coupons',
        label: 'Coupons'
    }
];

export const followUpHeadCells = [
    { id: 'campaign', numeric: false, disablePadding: false, label: 'Campaign' },
    { id: 'action', numeric: false, disablePadding: false, label: 'Action' },
    { id: 'lastReachOutDate', numeric: true, disablePadding: false, align: 'left', label: 'Last reach out date' },
    { id: 'remarks', numeric: false, disablePadding: false, label: 'Remarks' },
    { id: 'created_by', numeric: false, disablePadding: false, label: 'Created by' },
    { id: 'nextActionDate', numeric: true, disablePadding: false, align: 'left', label: 'Next action at' }
];

export const requirementHeadCells = [
    { id: 'reqCode', numeric: false, disablePadding: false, label: 'Requirement Code' },
    { id: 'score', numeric: true, disablePadding: false, align: 'left', label: 'Score', minWidth: '100px' },
    { id: 'leadType', numeric: false, disablePadding: false, label: 'Potential Lead' },
    { id: 'destination', numeric: false, disablePadding: false, label: 'Destination' },
    { id: 'travelDate', numeric: false, disablePadding: false, label: 'Date of Travel' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
    { id: 'remarks', numeric: false, disablePadding: false, label: 'Remarks' },
    { id: 'updatedAt', numeric: false, disablePadding: false, label: 'Last Updated at' },
    { id: 'followUpDate', numeric: false, disablePadding: false, label: 'Next Follow Up Date' },
    { id: 'pax', numeric: false, disablePadding: false, label: 'No of Pax' },
    { id: 'category', numeric: false, disablePadding: false, label: 'Category' },
    { id: 'createdAt', numeric: false, disablePadding: false, label: 'Created At' }
];

export const ticketsHeadCells = [
    { id: 'ticket_code', numeric: false, disablePadding: false, align: 'left', label: 'Ticket Code', showSort: false },
    { id: 'ticket_status', numeric: false, disablePadding: false, align: 'left', label: 'Ticket Status', showSort: false },
    { id: 'reference_id', numeric: true, disablePadding: false, align: 'left', label: 'Reference Id', showSort: false },
    { id: 'issue_category', numeric: true, disablePadding: false, align: 'left', label: 'Issue Category', showSort: false },
    { id: 'request_type', numeric: true, disablePadding: false, align: 'left', label: 'Request Type', showSort: false },
    { id: 'tags', numeric: true, disablePadding: false, align: 'left', label: 'Tags', showSort: false },
    { id: 'team', numeric: true, disablePadding: false, align: 'left', label: 'Team', showSort: false },
    { id: 'assigned_to', numeric: true, disablePadding: false, align: 'left', label: 'Assignee', showSort: false },
    { id: 'priority', numeric: true, disablePadding: false, align: 'left', label: 'Priority', showSort: false },
    { id: 'created_by', numeric: true, disablePadding: false, align: 'left', label: 'Created By', showSort: false },
    { id: 'next_action_at', numeric: false, disablePadding: false, align: 'left', label: 'Next Action At', showSort: true },
    { id: 'comment_by', numeric: false, disablePadding: false, align: 'left', label: 'Comment By', showSort: false },
    { id: 'updated_at', numeric: false, disablePadding: false, align: 'left', label: 'Updated At', showSort: true }
];

export const headCells = [
    { id: 'memberId', numeric: false, disablePadding: false, align: 'left', label: 'Member Id', showSort: false },
    { id: 'score', numeric: true, disablePadding: false, align: 'left', label: 'Potential Score', showSort: true },
    { id: 'behaviourScore', numeric: true, disablePadding: false, align: 'left', label: 'Behaviour Score', showSort: true },
    { id: 'potential', numeric: true, disablePadding: false, align: 'left', label: 'Buying Potential', showSort: false },
    { id: 'lastActivityDate', numeric: true, disablePadding: false, align: 'left', label: 'Last reach out date', showSort: true },
    { id: 'bookingTarget', numeric: true, disablePadding: false, align: 'left', label: 'Booking Target', showSort: false },
    { id: 'nextActionAt', numeric: false, disablePadding: false, align: 'left', label: 'Next action date', showSort: true }
];

export const bookingHeadCells = [
    { id: 'bookingCode', numeric: true, disablePadding: false, align: 'left', label: 'Booking Code' },
    { id: 'category', numeric: false, disablePadding: false, label: 'Category' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
    { id: 'bookingDate', numeric: false, disablePadding: false, label: 'Booking Date' },
    { id: 'destination', numeric: false, disablePadding: false, label: 'Destination' },
    { id: 'travelDate', numeric: false, disablePadding: false, label: 'Date of Travel' },
    { id: 'amountInBookingCurrency', numeric: false, disablePadding: false, label: 'Amount in Booking Currency (Excluding Bank Charges)' },
    { id: 'amountInInr', numeric: false, disablePadding: false, label: 'Amount in INR' }
];

export const bookingTargetHeadCells = [
    { id: 'target', numeric: true, disablePadding: false, align: 'left', label: 'Target' },
    { id: 'target_month', numeric: false, disablePadding: false, label: 'Target Month' },
    { id: 'created_by', numeric: false, disablePadding: false, label: 'Created By' },
    { id: 'created_at', numeric: false, disablePadding: false, label: 'Created At' }
];

export const businessDocumentsHeadCells = [
    { id: 'document_type', numeric: true, disablePadding: false, align: 'left', label: 'Document Type' },
    { id: 'document_link_1', numeric: false, disablePadding: false, label: 'Document link 1 (Front)' },
    { id: 'document_link_2', numeric: false, disablePadding: false, label: 'Document link 2 (Back)' },
    { id: 'document_status', numeric: false, disablePadding: false, label: 'Document Status' },
    { id: 'reason', numeric: false, disablePadding: false, label: 'Reason' },
    { id: 'comment', numeric: false, disablePadding: false, label: 'Comment' },
    { id: 'created_by', numeric: false, disablePadding: false, label: 'Created By' },
    { id: 'created_at', numeric: false, disablePadding: false, label: 'Created At' }
];

export const escalationsHeadCells = [
    { id: 'ticket_code', numeric: false, disablePadding: false, label: 'Ticket Code', showSort: false },
    { id: 'ticket_status', numeric: false, disablePadding: false, label: 'Ticket Status', showSort: false },
    { id: 'reference_id', numeric: true, disablePadding: false, align: 'left', label: 'Reference Id', showSort: false },
    { id: 'issue_category', numeric: false, disablePadding: false, label: 'Issue Category', showSort: false },
    { id: 'request_type', numeric: true, disablePadding: false, align: 'left', label: 'Request Type', showSort: false },
    { id: 'comment_by', numeric: true, disablePadding: false, align: 'left', label: 'Comment By', showSort: false },
    { id: 'updated_at', numeric: true, disablePadding: false, align: 'left', label: 'Updated At', showSort: true }
];

export const COMPONENT_MAP = {
    followUp: MemberFollowUp,
    requirement: Requirements,
    searches: MemberSearch,
    bookings: MemberBookings,
    tickets: Tickets,
    escalations: Escalations,
    orgDetails: EditOrganizationDetails,
    rechargeHistory: RechargeHistoryTable,
    Coupons: CouponsMaster
};

export const initialFollowupData = {
    action: null,
    campaign: null,
    next_action_at: null,
    remarks: ''
};

export const SEARCH_TYPE = 'search';
export const BOOKINGS_TYPE = 'booking';
export const REQUIREMENTS_TYPE = 'requirement';
export const DATE_FILTER_TYPE = 'created_at';
export const REQUIREMENT_EDITABLE_FIELDS = ['status', 'remarks', 'followUpDate', 'leadType'];

export const DEFAULT_ORDER = 'desc';
export const DEFAULT_ORDER_BY = 'created_at';
export const DEFAULT_ORDER_BY_TABLE_VIEW = 'lastActivityDate';
export const DEFAULT_FILTERS = {
    ordering: [{ id: `-created_at` }]
};

export const MODULE_ACCESS_MEMBER_PRIORITY_DASHBOARD = 'MEMBER_PRIORITY_DASHBOARD';
export const MODULE_ACCESS_MEMBER_PRIORITY_DASHBOARD_SIDE_NAV = 'MEMBER_PRIORITY_DASHBOARD_SIDENAVBAR';

export const DURATION_FILTER_OPTIONS = [
    {
        label: 'Last 1 year',
        value: 'all'
    },
    {
        label: 'Last 90 days',
        value: 'last_90_days'
    },
    {
        label: 'Last 60 days',
        value: 'last_60_days'
    },
    {
        label: 'Last 30 days',
        value: 'last_30_days'
    },
    {
        label: 'Last 15 days',
        value: 'last_15_days'
    },
    {
        label: 'Last 7 days',
        value: 'last_7_days'
    },
    {
        label: 'Yesterday',
        value: 'yesterday'
    }
];

export const REQUIREMENT_DURATION_FILTER_OPTIONS = [
    {
        label: 'Yesterday',
        id: 'yesterday'
    },
    {
        label: 'Last 7 days',
        id: 'last_7_days'
    },
    {
        label: 'Last 15 days',
        id: 'last_15_days'
    },
    {
        label: 'Last 30 days',
        id: 'last_30_days'
    },
    {
        label: 'Last 60 days',
        id: 'last_60_days'
    },
    {
        label: 'Last 90 days',
        id: 'last_90_days'
    }
];

export const INTERVAL_OPTIONS = [
    {
        label: 'Monthly',
        value: 'month'
    },
    {
        label: 'Weekly',
        value: 'week'
    }
];

export const WEEKLY_INTERVAL_OPTIONS = [
    {
        label: 'Week 1',
        value: 'week1'
    },
    {
        label: 'Week 2',
        value: 'week2'
    },
    {
        label: 'Week 3',
        value: 'week3'
    },
    {
        label: 'Week 4',
        value: 'week4'
    },
    {
        label: 'Week 5',
        value: 'week5'
    },
    {
        label: 'Week 6',
        value: 'week6'
    }
];

export const STATUS_REQUESTS = [
    {
        id: 'all',
        title: 'All'
    },
    {
        id: 'open',
        title: 'Open'
    },
    {
        id: 'close',
        title: 'Close'
    }
];

export const CHANNEL_REQUESTS = [
    // {
    //     id: 'all',
    //     title: 'All'
    // },
    {
        id: 2,
        title: 'Internal'
    },
    {
        id: 1,
        title: 'Travclan Help'
    }
];

export const CONVERSATION_DROPDOWN_RAISE_NEW_QUERY = [
    {
        id: 'travel_agents_and_travellers',
        name: 'Travel Agents and Travellers',
        label: 'Travel Agents and Travellers',
        value: 4
    },
    {
        id: 'travel_agents',
        name: 'Travel Agents Only',
        label: 'Travel Agents Only',
        value: 1
    },
    {
        id: 'internal_queries',
        name: 'Internal Queries',
        label: 'Internal Queries',
        value: 2
    }
];
